module.exports = __webpack_public_path__ + "static/share-0cb19586cba30a633a621081bdc90b2c.jpg";